import React, { useState } from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { portfolio, services } from '../data/siteData';
import { useReveal } from '../hooks/useReveal';
import './Inner.css';

function R({ children, className }) { const r = useReveal(); return <div ref={r} className={`reveal ${className||''}`}>{children}</div>; }

export function Portfolio() {
  const [filter, setFilter] = useState('All');
  const cats = ['All', ...Array.from(new Set(portfolio.map(p => p.category)))];
  const shown = filter === 'All' ? portfolio : portfolio.filter(p => p.category === filter);
  return (
    <div>
      <section className="page-hero">
        <div className="ph-orb ph-orb-1" /><div className="ph-orb ph-orb-2" />
        <div className="container page-hero-inner">
          <div className="badge"><div className="badge-dot">✦</div>Case Studies</div>
          <h1 className="ph-title">Results, <span className="grad-text">not promises</span></h1>
          <p className="ph-sub">Real metrics from shipped products. No inflated numbers, no vanity stats.</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="port-filters">
            {cats.map(c => (
              <button key={c} className={`port-filter${filter===c?' active':''}`} onClick={() => setFilter(c)}>{c}</button>
            ))}
          </div>
          <div className="port-grid-page">
            {shown.map(p => (
              <R key={p.id}>
                <Link to={`/portfolio/${p.id}`} className="pcard">
                  <div className="pcard-thumb" style={{ background: p.thumbBg }}>{p.thumb}</div>
                  <div className="pcard-body">
                    <div className="pcard-cat">{p.category}</div>
                    <h3>{p.title}</h3>
                    <p>{p.summary}</p>
                    <div className="pcard-metrics">
                      {p.metrics.slice(0,2).map(m => <div key={m.label} className="pm"><b>{m.value}</b> {m.label}</div>)}
                    </div>
                  </div>
                </Link>
              </R>
            ))}
          </div>
          <div style={{ textAlign:'center', marginTop:48 }}>
            <Link to="/get-quote" className="btn-grad">Start your own success story →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}

export function PortfolioDetail() {
  const { id } = useParams();
  const item = portfolio.find(p => p.id === id);
  if (!item) return <Navigate to="/portfolio" replace />;
  const svc = services.find(s => s.id === item.service);
  return (
    <div>
      <section className="page-hero">
        <div className="ph-orb ph-orb-1" />
        <div className="container page-hero-inner">
          <Link to="/portfolio" className="back-link">← All case studies</Link>
          <div className="port-hero-thumb" style={{ background: item.thumbBg }}>{item.thumb}</div>
          <div className="pcard-cat" style={{ marginBottom:10 }}>{item.category} · {item.year}</div>
          <h1 className="ph-title">{item.title}</h1>
          <p className="ph-sub">{item.summary}</p>
        </div>
      </section>
      <section className="section">
        <div className="container port-detail-grid">
          <div>
            <h2 className="svc-section-head">The story</h2>
            {item.description.split('\n\n').map((p,i) => <p key={i} className="svc-detail-para">{p}</p>)}
          </div>
          <div>
            <div className="port-metrics-card">
              <h3>Key results</h3>
              <div className="port-metrics-list">
                {item.metrics.map(m => (
                  <div key={m.label} className="pml-item">
                    <div className="pml-num" style={{ color: m.color }}>{m.value}</div>
                    <div className="pml-label">{m.label}</div>
                    <div className="pml-bar"><div className="pml-fill" style={{ background: m.color, width:'80%' }} /></div>
                  </div>
                ))}
              </div>
            </div>
            <div className="port-tech-card">
              <h3>Tech stack</h3>
              <div className="port-tech-chips">
                {item.tech.map(t => <span key={t} className="tech-chip">{t}</span>)}
              </div>
            </div>
            <div className="port-info-card">
              <div className="pic-row"><span>Client</span><strong>{item.client}</strong></div>
              <div className="pic-row"><span>Timeline</span><strong>{item.timeline}</strong></div>
              <div className="pic-row"><span>Service</span><strong>{svc?.title || item.service}</strong></div>
              <div className="pic-row"><span>Year</span><strong>{item.year}</strong></div>
            </div>
            <Link to="/get-quote" className="btn-grad" style={{ display:'block', textAlign:'center', marginTop:16 }}>Build something similar →</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
